import { Flex, Skeleton } from '@mantine/core';

import styles from './Article.module.css';

export const ArticleSkeleton = () => {
  return (
    <Flex className={styles.root}>
      <Flex w="100%" gap={30} direction="column">
        <Flex w="90%" gap={10} direction="column">
          <Skeleton width="100%" height={16} />
          <Skeleton width="75%" height={16} />
        </Flex>
        <Flex direction="column" gap={10}>
          <Skeleton width="100%" height={7} />
          <Skeleton width="100%" height={7} />
          <Skeleton width="25%" height={7} />
        </Flex>
      </Flex>

      <Skeleton className={styles.image} />
    </Flex>
  );
};
